import type { FC, ReactNode } from "react";
import { Dialog } from "react-aria-components";
import { CenteredModal } from "../Modal/centeredModal.js";
import { ModalSize } from "../Modal/modal.js";

export interface AskAlpharunModalProps {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  /** Left history rail; hidden below the `md` breakpoint. */
  history?: ReactNode;
  /** The main chat column — typically a `ChatThread`. */
  children: ReactNode;
}

/**
 * Chrome for the expanded "Ask Alpharun" chat: the shared modal frame at full
 * size, with an optional history rail beside the chat column.
 */
export const AskAlpharunModal: FC<AskAlpharunModalProps> = ({
  isOpen,
  onOpenChange,
  history,
  children,
}) => (
  <CenteredModal
    size={ModalSize.Full}
    isDismissable
    isOpen={isOpen}
    onOpenChange={onOpenChange}
  >
    <Dialog
      aria-label="Ask Alpharun expanded chat"
      className="h-full outline-none"
    >
      <div className="flex h-full min-h-0 min-w-0 overflow-hidden bg-card">
        {history ? (
          <aside
            aria-label="Chat history"
            className="hidden h-full w-[320px] shrink-0 flex-col border-r border-border-light md:flex"
          >
            {history}
          </aside>
        ) : null}
        <div className="flex min-h-0 min-w-0 flex-1 flex-col">{children}</div>
      </div>
    </Dialog>
  </CenteredModal>
);
